var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'z-player': true, 'z-player--no-title': _vm.is_hidden_name }},[_c('a-player',{staticClass:"zorra-aplayer",attrs:{"music":_vm.music}}),_c('div',{staticClass:"z-player__icons"},[_vm._t("controls")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }